import React from 'react';
import PropTypes from 'prop-types';

const changeHanlder = (onChange) => (event) => {
    try{
        if(onChange){
            const { target } = event;
            const { value } = target;
            onChange(value);
        }
    }catch(e){}
}

/**
 * Simple component for wrapping RadioButton components
 * @param {*} param0 
 */
function RadioButtonGroup({ onChange, name, children }){
    return (<div className='radio-button-group' onChange={changeHanlder(onChange)}>
         {React.Children.map(children, child => {
            return React.cloneElement(child, {name});
        })}
    </div>)
}

RadioButtonGroup.propTypes = {
    /** change function will be called with the value of the radio button */
    onChange: PropTypes.func,
    /** Name of the radio group, this prop will be applied to all child radio buttons */
    name: PropTypes.string.isRequired
};


export default React.memo(RadioButtonGroup);
